import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

import useStyles from '../styles';

export interface DrawerFooterProps {
  className?: string;
  grayBackground?: boolean;
}

export const DrawerFooter: FC<PropsWithChildren<DrawerFooterProps>> = ({
  children,
  className,
  grayBackground = false,
  ...props
}) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(classes.footerContainer, className, {
        [classes.footerContainerDefault]: !grayBackground,
        [classes.backgroundGray]: grayBackground,
      })}
      {...props}
    >
      <Grid className={classes.footerContent} container direction="row">
        {children}
      </Grid>
    </div>
  );
};
